"use strict";

exports.__esModule = true;
var _Spinner = require("./Spinner");
Object.keys(_Spinner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Spinner[key]) return;
  exports[key] = _Spinner[key];
});